export default __webpack_public_path__ + "static/ForgetSectionLeft_us-3bedf23892dbfe84a31ee4e25e776461.png";